var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSellPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.900391,
    width: 64,
    height: 64,
    fill: "url(#pattern0_187_3961)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_187_3961",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_187_3961",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_187_3961",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOxAAADsQBlSsOGwAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAASDSURBVHic7ZtbiFVVGMf/nzpa2pQjlRJdCSynxteil5IIKwxCDITqpXwxicGH8KGL6EOEEUn40lNQZEkWacWURRGEhEJU6uSlC+FUgjhNOuQ44/jrYZ8je5b7fjnrVOcHB2bt9e31/75vr733uuyRSgL0Ap8Cp0lmHNgL3FlWs20AFgKjKYG7TAL3+Pa9EoAdOYNvctC3702szMnAH5IWNIqjkr5OMO+TND9U7jGzkTL63gFOhK7qdym2bzu9YH6SfauY5tsB33QS4NsB33QS4NsB35R9Dc4NtTFpZicTbOdImhk69JeZnSuj36FDeTLfAsBsSddJml2DH2ckDbXlyBC4HRggmM3VySSwG1jmO+bzAKuBszUHHsVLvmMXsLRxVXzxZCvijH0GAPsl3dIKJ2IYkXStmZ2qUyRyIAT0yW/wkjRX0tK6ReJGgovqFs5Ib90CcQm4pG7hjHTXLVB0LoCkAUk7JUUNZ49JekPSkZjzv5C0XdJEQf16AR5LeUI/HbJd49T9CSxo1F0EDDr1r4TOXZGi82LdsRbtAR+E/t7p1O01s2OSZGZjknblOLflFE1AuOuOO3Vp5fPnmplb13L+9+sBnQT4dsA3nQT4dsA3nQT4diCBMUm/1C0yo26BnIxJ+kzSO5LeT1plrop2SECuoAmW17ubo82ytEMCrkxb9CBYkL1b0kOSlkuaAwwqSNo2M/uhqLj3BMQFHxW0Y9Irab2k9WWS4T0BYTIEHUfhZHh/CwBdwMPADknDCmaIjyp78C7NZAwC3wPPAlfHGbdDD3hTwRWvg77Gby2w2MyGXAPvPUDSgy3Q6JG0JKqiHRLQ5VOnHRLglU4CfDvgm04CamjT3W8s9RlOCkclrZQ0S9IDkv7O20DRBIS3rG516m4CpofK7h6jqzmZoPOrpHWStmjqBsyEpE2SFpnZNjMbN7MPJb2X0NbZqINFB0JbgJ6GIxucuhslvQVsVfDuvc+pd7fdhiVdEaGBpHvN7KAkAT9K2izpS0lrzOxAxDmXJ/g8nFDnKKfvDJXhEUfL3TlqcgaYEbIzgm8WLrilgIuBTSm6t0XFGncLjGXOVn6ud8pHY+xmSlrVLJgZZvaJmRE2Au6XtE/SUym6kTpxCTic0lgZbnbKuxNsXwYWR1UAVwGvS/pIwW2XxM9m9ntmD4FpwE8VdPcoDjlaS1Ls9xNMk5v2XUA/cDKH5muZgw8Jpe3cluGakM4s4HiK/cfAHcBK4EABveW5E9Bwrh84V0AwjSccnRdq0GjyG1B8wgUsA76t2Kk9jsYNwETFGk2eSYov0ygNmCfpROjQV7rw/Z+Xz8MfSwObJfWXbNNlSMFgabRUK8A8J6vvVuPfFI1ugu5aJSvSdLMOhUc19UOH7KOqjDRWh1cpeWich61mtr2itiRgLcF/hx4B3Hd5lTr9FVz5PYRenVU6Nz3dqhKd50sE/w0QNbf4dwE8Tv4v1HcBl/r2vTKAu4DDGQI/DTxHaPL0n4HgW8ONwKmY4AeAhb79rB3gMoIH5CAwArwKuIsxufkHp/zFYUbQgQsAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellPrice);
export default __webpack_public_path__ + "static/media/sell_price.8cf4d6942eb4f59af361cf170bc51e38.svg";
export { ForwardRef as ReactComponent };